import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { PagedResult } from '../shared/model/generic-paged-result.model';
import { DatagridService } from '../shared/index';
import { TranslationService, NotificationService, UtilService } from '../shared/index';
import { FormBuilder } from './shared/service/form-builder.service';
import { FormTemplate } from './shared/model/form-template.model';
import { FormSearch } from './shared/model/form-search.model';

@Component({
  selector: 'wl-forms-dashboard',
  templateUrl: 'forms-dashboard.component.html',
  providers: [FormBuilder],
    standalone: false
})
export class FormsDashboardComponent implements OnInit {
  private _datagridService: DatagridService;
  private _translationService: TranslationService;
  private _notificationService: NotificationService;
  private _utilService: UtilService;
  private _router: Router;
  private _formsService: FormBuilder;

  public formsResult: PagedResult<Array<FormTemplate>> = new PagedResult<Array<FormTemplate>>([]);
  public isBusy: boolean = false;
  public isSearching: boolean = false;
  public searchParams: FormSearch = new FormSearch();

  public constructor(
    datagridService: DatagridService,
    translationService: TranslationService,
    notificationService: NotificationService,
    utilService: UtilService,
    router: Router,
    formsService: FormBuilder
  ) {
    this._datagridService = datagridService;
    this._translationService = translationService;
    this._notificationService = notificationService;
    this._utilService = utilService;
    this._router = router;
    this._formsService = formsService;
  }

  ngOnInit() {}

  public lazyLoadForms($event: any): void {
    this._datagridService.mapDatagridPagingToPagedSearch($event, this.searchParams);

    if (!this.isSearching) {
      this.getForms();
    }
  }

  public getForms(): void {
    if (this.isSearching) return;

    this.isSearching = true;

    this._formsService.searchForms().then(
      (result: PagedResult<Array<FormTemplate>>) => {
        this._datagridService.mapPagedResultsToPagedSearch(result, this.searchParams);
        this.formsResult = result;
        this.isSearching = false;
      },
      () => {
        this.isSearching = false;
      }
    );
  }

  public editForm(form: FormTemplate): void {
    this._router.navigate(['forms/formbuilder/', form.Id]);
  }
}
